import React, { useEffect, useState } from 'react';
import { UserRound } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext.tsx';
import { getSafeMediaUrl } from '../utils/safeUrl.ts';

interface ContactAvatarProps {
  photo?: string | null;
  name?: string;
  className?: string;
  iconClassName?: string;
  testIdPrefix?: string;
}

const ContactAvatar: React.FC<ContactAvatarProps> = ({
  photo,
  name,
  className = 'h-10 w-10 rounded-full',
  iconClassName = 'h-5 w-5',
  testIdPrefix,
}) => {
  const { isDark } = useTheme();
  const safePhoto = getSafeMediaUrl(photo, 'image');
  const generatedPlaceholder = Boolean(safePhoto && /^https?:\/\/(?:[^/]+\.)?ui-avatars\.com(?:[/:?#]|$)/i.test(safePhoto));
  const [failedPhoto, setFailedPhoto] = useState<string | null>(null);

  useEffect(() => {
    setFailedPhoto(null);
  }, [safePhoto]);

  if (safePhoto && !generatedPlaceholder && failedPhoto !== safePhoto) {
    return (
      <img
        data-testid={testIdPrefix ? `${testIdPrefix}-image` : undefined}
        src={safePhoto}
        alt={name ? `Foto de ${name}` : 'Foto do contato'}
        className={`shrink-0 border object-cover ${isDark ? 'border-[#27364D]' : 'border-sminy-border'} ${className}`}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setFailedPhoto(safePhoto)}
      />
    );
  }

  return (
    <span
      data-testid={testIdPrefix ? `${testIdPrefix}-placeholder` : undefined}
      aria-label="Contato sem foto"
      className={`grid shrink-0 place-items-center border ${isDark ? 'border-[#27364D] bg-[#27364D]/35 text-[#7E8CA0]' : 'border-sminy-border bg-slate-100 text-slate-500'} ${className}`}
    >
      <UserRound className={iconClassName} aria-hidden="true" />
    </span>
  );
};

export default ContactAvatar;
